// extracted by mini-css-extract-plugin
export var paragraph = "styles-module--paragraph--6052f";
export var table = "styles-module--table--fdb62";
export var wrapper = "styles-module--wrapper--a3b15";